import '../../../styles/Modals.css'
import '../../../styles/Shared.css'
import './UpdateEntityModals.css'
import "react-datepicker/dist/react-datepicker.css";
import Row from 'react-bootstrap/Row';

import { FiEdit2 } from "react-icons/fi";

import { ModalStates } from './UpdateEntityModalStates';
import { IsErrorState, GetInputValidationErrorText } from './InputValidation';
import { useEffect, useState, useRef } from 'react';

import DatePicker from "react-datepicker";
import { subYears } from "date-fns";
import { calculateConceptualAge } from '../../../utilities/ConceptualAgeUtilities';

function UpdateEntityModalDataLineConceptualAgeEdit(props) {

  const [show, setShow] = useState(false);
  const [birthDate, setBirthDate] = useState(null);
  const baseGestationalAge = useRef(props.gestationalAge);
  const ignoreNextValueChange = useRef(false);

  // When CA value changes from parent (new patient loaded), sync the base GA and reset birth date.
  // Skip when the change was triggered internally by a birth date selection or GA recalculation.
  // This effect must be declared before the GA effect so it runs first in the same render.
  useEffect(() => {
    if (ignoreNextValueChange.current) {
      ignoreNextValueChange.current = false;
      return;
    }
    baseGestationalAge.current = props.gestationalAge;
    setBirthDate(null);
  }, [props.value]);

  // When GA changes by the user (differs from the base), clear or recalculate CA
  useEffect(() => {
    if (props.gestationalAge === baseGestationalAge.current) return;
    baseGestationalAge.current = props.gestationalAge;
    if (birthDate) {
      ignoreNextValueChange.current = true;
      const conceptualWeeks = calculateConceptualAge(birthDate, parseFloat(props.gestationalAge));
      props.inputChanged(conceptualWeeks.toFixed(2), props.parameterName);
    } else {
      props.inputChanged('', props.parameterName);
    }
  }, [props.gestationalAge]);

  // function getTextEntryDisabled() {
  //   if (props.disabled)
  //     return true;


  //   switch (props.modalState) {
  //     case ModalStates.Add:
  //     case ModalStates.Edit:
  //       return false;
  //     case ModalStates.ConfirmAdd:
  //     case ModalStates.ConfirmEdit:
  //     default:
  //       return true;
  //   }
  // }

  function isGestationalAgeValid() {
    return props.gestationalAge &&
           props.gestationalAge !== 0 &&
           props.gestationalAge !== '-' &&
           props.gestationalAge !== '';
  }

  function handleBirthDateChange(date) {
    setBirthDate(date);

    if (date && props.gestationalAge) {
      const conceptualWeeks = calculateConceptualAge(date, parseFloat(props.gestationalAge));
      ignoreNextValueChange.current = true;
      props.inputChanged(conceptualWeeks.toFixed(2), props.parameterName);
    }
  }



  return (
    <div>
      <Row className='AddEntityModalContainer form-group'>
        <div className='col-sm-4 col-form-label'>
          <label className="AddEntityModalLabel" htmlFor={`${props.labelName}-input`}>{props.labelName}
            <label className={props.required === true ? 'RequiredStar' : 'InvisibleCollapse'}>*</label>
          </label>
          <p className={!props.helpText ? 'InvisibleCollapse' : ''}><small>{props.helpText}</small></p>
        </div>
        <div className={!props.disabled ? 'col-sm-7' : 'col-sm-8'}>
          <input className={IsErrorState(props.errorState) ? 'AddEntityModalEntryError ' : 'AddEntityModalEntry'}
            id={`${props.labelName}-input`}
            disabled={true}
            type={'text'}
            value={props.value ? `${props.value} weeks (as of ${new Date().toLocaleDateString()})` : ""} />
          <label className={IsErrorState(props.errorState) ? 'InputValidationErrorMessage' : 'InvisibleCollapse'}>
            {GetInputValidationErrorText(props.errorState, props.labelName, props.min, props.max, props.entryMinLength, props.entryMaxLength)}
          </label>

          {show && !props.disabled&&
            <div>
              <label className="AddEntityModalLabel mt-2" htmlFor='birthdate-input'>BIRTH DATE</label>
              <DatePicker
                showIcon
                className='AddEntityModalEntry'
                selected={birthDate}
                id='birthdate-input'
                onChange={handleBirthDateChange}
                maxDate={new Date()}
                minDate={subYears(new Date(), 5)}
                placeholderText="Select birth date"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onKeyDown={(e) => e.preventDefault()}
                wrapperClassName="w-100"
              />

              <p className="mt-1 mb-2 neo_gen_text">Note: For HIPAA compliance, the birth date entered here will not be stored. It is used only temporarily to calculate the conceptual age.</p>
            </div>
          }

        </div>

        { !props.disabled &&  

          <div className='col-sm-1  col-form-label'>
            {isGestationalAgeValid() ? (
              <a className="neo-icon icon-link icon-link-hover"
                onClick={() => setShow(!show)}
                href='#'>
                <FiEdit2 size={18} />
              </a>
            ) : (
              <span className="neo_gen_text" style={{fontSize: '0.75rem', color: '#999'}}>
                Enter GA first
              </span>
            )}
          </div>
        }

      </Row>
    </div>
  );
}

export default UpdateEntityModalDataLineConceptualAgeEdit;